import React, { useEffect, useState } from "react";
import { getServiceGuideData } from "../api";
import DtcHeading from "../components/DtcHeading";
import ServiceCard from "../components/ServiceCard";
import { AiOutlineClose } from "react-icons/ai";
import LargeContent from "../components/LargeContent";

const SocialMediaServiceGuide = () => {
  const [data, setData] = useState(null);
  const [isContentLarge, setIsContentLarge] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const getServiceGuide = async (payload) => {
    const data = await getServiceGuideData(payload);
    setData(data);
  };
  useEffect(() => {
    getServiceGuide({ serviceType: "Internet Contents" });
  }, []);
  return (
    <div className="page-wrapper serviceguide serviceguide_architecture">
      {data ? (
        <>
          {!isContentLarge ? (
            <>
              <DtcHeading />
              <div className="content_container">
                {data?.map((item, index) => (
                  <div key={index}>
                    <ServiceCard
                      data={item}
                      onClick={(data) => {
                        setIsContentLarge(true);
                        setSelectedCard(data);
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <LargeContent
              selectedCard={selectedCard}
              onClose={() => setIsContentLarge(false)}
              data={data}
              onServiceCardClick={(singleData) => {
                setIsContentLarge(true);
                setSelectedCard(singleData);
              }}
            />
          )}
        </>
      ) : (
        <>No data found</>
      )}
    </div>
  );
};

export default SocialMediaServiceGuide;
